import { API } from 'c-sdk';

const api = new API({ baseUrl: '/api/v1/' });

export default api;
